import { NavLink } from 'react-router';

import { BuildStamp } from '@/components/layout/BuildStamp';
import { Button } from '@/components/ui/button';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';

/**
 * サイドバー下部の個人メニュー。
 *
 * ここに置くものは**その人にしか紐付かない**。MCP のトークンは発行した
 * 本人の user_id に固定されるし、アカウント設定も本人のものしか触れない。
 * テナント設定と同じ並びに置くと全社の設定に見えるので、名前の下に畳む。
 *
 * ロールでは出し分けない。どれも全ロールが開ける。
 *
 * ヘルプだけは個人にも全社にも紐付かないが、ここに置く。上の SECTIONS は
 * テナントのマスタを操作する並びなので、そこに混ぜると管理対象に見える。
 */
const ITEMS = [
  { to: '/settings/account', label: 'アカウント' },
  { to: '/settings/mcp', label: 'MCP接続' },
  { to: '/help', label: 'ヘルプ' },
];

export function UserMenu({
  userName,
  userRoleLabel,
  onSignedOut,
  onNavigate,
}: {
  userName: string;
  /** 表示用のロール名 */
  userRoleLabel: string;
  onSignedOut: () => void;
  /** モバイルのドロワーの中から遷移したときに閉じてもらう */
  onNavigate: () => void;
}) {
  async function signOut() {
    // 失敗しても画面は未ログインに戻す (Cookie が既に無効な場合など)
    await api.post('/api/auth/logout').catch(() => undefined);
    onSignedOut();
  }

  return (
    <div className="mt-auto flex flex-col gap-2 border-t border-line px-3 pt-4">
      <div className="flex flex-col gap-1 px-2.5">
        <span className="text-[13px]">{userName}</span>
        <span className="text-xs text-ink-subtle">{userRoleLabel}</span>
      </div>
      <nav className="flex flex-col gap-0.5">
        {ITEMS.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            onClick={onNavigate}
            className={({ isActive }) =>
              cn(
                'px-2.5 py-2.5 text-sm',
                isActive ? 'bg-brand-700 text-surface-raised' : 'text-ink-muted hover:text-ink',
              )
            }
          >
            {item.label}
          </NavLink>
        ))}
        <Button variant="ghost" className="justify-start px-2.5 py-2.5" onClick={signOut}>
          ログアウト
        </Button>
      </nav>
      {/* 問い合わせのときに貼ってもらう。押すとコピーできる。 */}
      <BuildStamp className="px-2.5 pb-1" />
    </div>
  );
}
